export default __webpack_public_path__ + "static/media/ge.652fc6f8.svg";